import { useEffect, useState } from "hono/jsx";

interface Player {
  id: string;
  color: string;
  isMe: boolean;
}

interface HUDProps {
  roomId: string;
}

export function HUD({ roomId }: HUDProps) {
  const [status, setStatus] = useState("Connecting...");
  const [players, setPlayers] = useState<Player[]>([]);
  const [coords, setCoords] = useState({ x: 0, y: 0, z: 0 });
  const [chunkDepth, setChunkDepth] = useState(1);

  useEffect(() => {
    const handleStatusUpdate = (e: CustomEvent) => {
      setStatus(e.detail);
    };

    const handlePlayersUpdate = (e: CustomEvent) => {
      setPlayers(e.detail);
    };

    const handleCoordsUpdate = (e: CustomEvent) => {
      setCoords(e.detail);
    };

    document.addEventListener(
      "pg:status:update",
      handleStatusUpdate as EventListener,
    );
    document.addEventListener(
      "pg:players:update",
      handlePlayersUpdate as EventListener,
    );
    document.addEventListener(
      "pg:coords:update",
      handleCoordsUpdate as EventListener,
    );

    return () => {
      document.removeEventListener(
        "pg:status:update",
        handleStatusUpdate as EventListener,
      );
      document.removeEventListener(
        "pg:players:update",
        handlePlayersUpdate as EventListener,
      );
      document.removeEventListener(
        "pg:coords:update",
        handleCoordsUpdate as EventListener,
      );
    };
  }, []);

  return (
    <div className="absolute top-3 left-3 font-mono text-white pointer-events-none select-none">
      <h1 className="text-lg font-bold">
        {roomId} <span className="text-sm opacity-50">{status}</span>
      </h1>

      <div className="mt-2 text-sm">
        <strong>Players:</strong>
        {players.map((p) => (
          <div key={p.id} style={{ color: p.color }}>
            {p.isMe ? "(You) " : ""}
            {p.id.slice(0, 4)}
          </div>
        ))}
      </div>

      <div className="mt-2 text-xs opacity-70">
        {coords.x.toFixed(1)}, {coords.y.toFixed(1)}, {coords.z.toFixed(1)}
      </div>

      <div className="mt-3 text-xs opacity-50">[ESC] Menu</div>
    </div>
  );
}
